module.exports = __webpack_public_path__ + "media/images/logo_icon-5a3bd8294e5aab3332f40bfacaf8e03c.png";